import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DashboardPage from './pages/DashboardPage';
import WarrantyListPage from './pages/WarrantyListPageRefactored';
import AddWarrantyPage from './pages/AddWarrantyPage';
import SmartWarrantyAssistantPage from './pages/SmartWarrantyAssistantPage';
import { Login, Register } from './components/auth';
import { ProtectedRoute } from './components/ProtectedRoute';
import { PublicRoute } from './components/PublicRoute';
import { Layout } from './components/ui';
import { AdminModule } from './components/admin/AdminModule';
// import { LoadingProvider } from './contexts/LoadingContext';
// import RouteTransitionManager from './components/RouteTransitionManager';
import './styles/main.css';
import './styles/admin.css';
import './styles/admin-gcp.css';
import './styles/admin-users.css';
import './styles/admin-analytics.css';
import './styles/admin-system.css';

function App() {
  return (
    // <LoadingProvider>
      <Router>
        {/* <RouteTransitionManager> */}
          <Routes>
            {/* Homepage Route */}
            <Route path="/" element={<HomePage />} />
            
            {/* Public Routes */}
            <Route path="/login" element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } />
            <Route path="/register" element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            } />

        {/* Protected Routes with Layout */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Layout>
              <DashboardPage />
            </Layout>
          </ProtectedRoute>
        } />
        
        <Route path="/warranties" element={
          <ProtectedRoute>
            <Layout>
              <WarrantyListPage />
            </Layout>
          </ProtectedRoute>
        } />

        <Route path="/warranty/new" element={
          <ProtectedRoute>
            <Layout>
              <AddWarrantyPage />
            </Layout>
          </ProtectedRoute>
        } />

                <Route path="/warranty/intelligence" element={
          <ProtectedRoute>
            <Layout>
              <SmartWarrantyAssistantPage />
            </Layout>
          </ProtectedRoute>
        } />

        {/* Admin Routes */}
        <Route path="/admin/*" element={
          <ProtectedRoute>
            <AdminModule />
          </ProtectedRoute>
        } />

            {/* Fallback redirects */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        {/* </RouteTransitionManager> */}
      </Router>
    // </LoadingProvider>
  );
}

export default App;
